import noop from 'lodash/noop';
import { createActions } from 'redux-actions';

export const transferToNumberActions = createActions(
  {
    TRANSFER_TO_NUMBER_ASSISTED_REQUEST: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    TRANSFER_TO_NUMBER_BLIND_REQUEST: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    TRANSFER_TO_NUMBER_ASSISTED_RESOLVE: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    TRANSFER_TO_NUMBER_GET_USERS_BY_QUERY: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
  },

  'TRANSFER_TO_NUMBER_ASSISTED_REQUEST_SUCCEEDED',
  'TRANSFER_TO_NUMBER_ASSISTED_REQUEST_FAILED',

  'TRANSFER_TO_NUMBER_BLIND_REQUEST_SUCCEEDED',
  'TRANSFER_TO_NUMBER_BLIND_REQUEST_FAILED',

  'TRANSFER_TO_NUMBER_ASSISTED_RESOLVE_SUCCEEDED',
  'TRANSFER_TO_NUMBER_ASSISTED_RESOLVE_FAILED',

  'TRANSFER_TO_NUMBER_GET_USERS_BY_QUERY_SUCCEEDED',
  'TRANSFER_TO_NUMBER_GET_USERS_BY_QUERY_FAILED',

  'TRANSFER_TO_NUMBER_MODAL_CLOSE',
  'TRANSFER_TO_NUMBER_MODAL_OPEN',

  'TRANSFER_TO_NUMBER_RESET_USERS',

  'TRANSFER_TO_NUMBER_REQUEST_STOP',

  //Should this be moved to WS?
  'TRANSFER_TO_NUMBER_WS_RESPONSE',
  'TRANSFER_TO_NUMBER_WS_TRANSFER_STARTED',
  'TRANSFER_TO_NUMBER_WS_TRANSFER_ANSWERED',
);
